import "./style.css";

export default class CookieBanner {
  static selector = ".cookie-banner";

  constructor(block) {
    this.block = block;
  }

  onAcceptClick = () => {
    this.block.addEventListener("transitionend", this.onTransitionEnded);
    this.block.style.opacity = "0";
    document.cookie = `cookie-banner=1`;
  };

  hideCookieBanner = () => {
    this.block.style.display = "none";
  };

  onTransitionEnded = () => {
    this.block.removeEventListener("transitionend", this.onTransitionEnded);
    this.hideCookieBanner();
  };

  onReady() {
    this.acceptButton = this.block.querySelector(".cookie-banner__cta");
    this.acceptButton.addEventListener("click", this.onAcceptClick);
  }

  onDestroy() {
    this.acceptButton.removeEventListener("click", this.onAcceptClick);
  }
}
